<template>
  <div class="page">
    <div class="rowFluid">
      <div class="span12">
        <div class="main">
          <other-carousel :content="allText">
          </other-carousel>
          <div class="introduce wow fadeInUp" style="padding: 50px 0">
            <div class="rowFluid">
              <div class="span12">
                <div class="container">
                  <h1 style="text-align: center; font-size: 32px;margin-bottom: 50px">法律声明</h1>
                  <p style="text-align: center; font-size: 16pt; font-weight: bold">法律声明</p>
                  <div>
                    <p style="font-size: 12pt; font-weight: bold; margin-bottom: 5px">1、网站版权说明</p>
                    <p style="font-size: 12pt; line-height: 30px">
                      本网站所载的所有材料或内容受版权法的保护，所有版权由武汉港迪软件信息技术有限公司（简称“港迪软件”）拥有，但注明引用其他方的内容除外。本站的内容，仅供您个人而非商业使用，您不得以任何方式修改、复制、公开展示、公布或分发或者以其他方式把它们用于任何公开或商业目的。禁止以任何目的把这些材料用于其他任何网站或其他平面媒体或网络计算机环境。本网站上的内容及编辑等形式均受版权法等法律保护，任何未经授权的使用都可能构成对版权、商标和其他法律权利的侵犯。如果您不接受或违反上述约定，您使用本站的授权将自动终止，同时您应立即销毁任何已下载或打印好的本站内容。
                    </p>
                  </div>
                  <div style="margin-top: 25px">
                    <p style="font-size: 12pt; font-weight: bold; margin-bottom: 5px">2、商标保护说明</p>
                    <p style="font-size: 12pt; line-height: 30px">
                      本网站所载的任何内容不应被视作未经港迪软件或其他方书面许可，以暗示、不反对或其他形式授予使用前述任何商标、标志的许可或权利。未经事先书面授权许可使用，任何人不得以任何方式使用港迪软件名称及商标、标记。 </p>
                  </div>
                  <div style="margin-top: 25px">
                    <p style="font-size: 12pt; font-weight: bold; margin-bottom: 5px">3、网站信息发布</p>
                    <p style="font-size: 12pt; line-height: 30px">
                      本网站所载的材料和信息，包括但不限于文本、图片、数据、观点、建议、网页或链路，虽然港迪软件力图在网站上提供准确的材料和信息，但港迪软件并不保证这些材料和内容的准确、完整、充分和可靠性，并且明确声明不对这些材料和内容的错误或遗漏承担责任，也不对这些材料和内容作出任何明示或默示的、包括但不限于有关所有权担保、没有侵犯第三方权利、质量和没有计算机病毒的保证。
                      港迪软件可以在没有任何通知或提示的情况下随时对本网站上的内容进行修改，为了得到最新版本的信息，请定时访问本网站。港迪软件在本网站上所提及的非港迪软件产品或服务仅仅是为了提供相关信息，并不构成对这些产品、服务的认可或推荐。港迪软件并不就网址上提供的任何产品、服务或信息做出任何声明、保证或认可，所有销售的产品和服务应受本公司的销售合同和条款的约束。
                    </p>
                  </div>
                  <div style="margin-top: 25px">
                    <p style="font-size: 12pt; font-weight: bold; margin-bottom: 5px">4、产品或服务须知</p>
                    <p style="font-size: 12pt; line-height: 30px">
                      由于互联网的国际性或无国界性，因此通过本站所提供的信息亦具有国际性，所以不是所有的在本站上所提到的产品或服务在您的国家或地区都提供，请联系当地的销售代表或代理商了解在您的国家或地区所提供的产品或服务。
                    </p></div>
                  <div style="margin-top: 25px">
                    <p style="font-size: 12pt; font-weight: bold; margin-bottom: 5px">5、第三方链接</p>
                    <p style="font-size: 12pt; line-height: 30px">
                      本网站可能保留有与第三方网站或网址的链接，访问这些链接将由用户自己作出决定，港迪软件并不保证这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性。港迪软件提供这些链接仅仅在于提供方便，并不表示港迪软件对这些信息的认可和推荐，也不是用于宣传或其他商业目的。
                    </p></div>
                  <div style="margin-top: 25px">
                    <p style="font-size: 12pt; font-weight: bold; margin-bottom: 5px">6、权利通知</p>
                    <p style="font-size: 12pt; line-height: 30px">
                      如您认为本网站的图片、文字、链接等侵犯您的合法权益，或其它第三方的合法权益，请立即与港迪软件客服取得联系，港迪软件将及时核实、处理。如果权利通知的陈述失实，权利通知提交者需承担由此造成的全部法律责任（包括但不限于各种赔偿、维权的费用等）。如您不确定港迪软件网站的资料是否侵犯了您的合法权益，建议您首先咨询专业人士。
                    </p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OtherCarousel from '../../components/OtherCarousel/OtherCarousel.vue'

export default {
  data () {
    return {
      allText: {
        bannerTitle: '',
        // bannerTitle: '以振兴民族工业为己任，打造国际知名品牌',
        bannerText: '',
        img: require('../../assets/images/ser.jpg')
      }
    }
  },
  components: {
    'other-carousel': OtherCarousel
  }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
#sample {
  height: 400px;
  overflow: hidden;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/page/legalStatement/legalStatement.vue